import { render, staticRenderFns } from "./RsaAccettazioneEditComponent.vue?vue&type=template&id=7d15d79a&scoped=true"
import script from "./RsaAccettazioneEditComponent.vue?vue&type=script&lang=js"
export * from "./RsaAccettazioneEditComponent.vue?vue&type=script&lang=js"
import style0 from "./RsaAccettazioneEditComponent.vue?vue&type=style&index=0&id=7d15d79a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d15d79a",
  null
  
)

export default component.exports